import React from 'react';
import '../styles/FormFields.css';

interface TextInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  multiline?: boolean;
  maxLength?: number;
}

const TextInput: React.FC<TextInputProps> = ({ 
  label, 
  value, 
  onChange, 
  placeholder = '', 
  multiline = false,
  maxLength = 250
}) => {
  return (
    <div className="form-field">
      <label className="form-label">{label}</label>
      {multiline ? (
        <>
          <textarea
            className="form-textarea"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            rows={4}
            maxLength={maxLength}
          />
          <div style={{ 
            fontSize: '12px', 
            color: '#6b7280', 
            textAlign: 'right', 
            marginTop: '4px' 
          }}>
            {value.length}/{maxLength}
          </div>
        </>
      ) : (
        <input
          type="text"
          className="form-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
        />
      )}
    </div>
  );
};

export default TextInput;





